<script setup lang="ts">
import type { ToastDescriptionProps } from 'reka-ui'
import type { HTMLAttributes } from 'vue'
import { ToastDescription } from 'reka-ui'

const props = defineProps<ToastDescriptionProps & { class?: HTMLAttributes['class'] }>()
const appConfig = useAppConfig()
const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props
  return delegated
})
</script>

<template>
  <ToastDescription :class="cn(appConfig.ui.toast.slots.description, props.class)" v-bind="delegatedProps">
    <slot />
  </ToastDescription>
</template>
